!function (e, n) {
  "object" == typeof exports && "undefined" != typeof module ? n(exports, require("web3modal")) : "function" == typeof define && define.amd ? define(["exports", "web3modal"], n) : n((e || self).UAuthWeb3Modal = {}, e.web3Modal);
}(this, function (e, n) {
  function t() {
    return t = Object.assign || function (e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = arguments[n];
        for (var o in t) {
          Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }
      }
      return e;
    }, t.apply(this, arguments);
  }
  var o;
  e.connector = function (e, r) {
    try {
      var i,
        c = function c(e) {
          if (null == i.wallet_type_hint) throw new Error("no wallet type present");
          var c;
          if (["web3", "injected"].includes(i.wallet_type_hint)) c = n.connectors.injected();else {
            if ("walletconnect" !== i.wallet_type_hint) throw new Error("Connector not supported");
            var l = "walletconnect";
            c = n.connectors.walletconnect(o.providerController.getProviderOption(l, "package"), t({
              network: r.network
            }, o.providerController.getProviderOption(l, "options")));
          }
          return c;
        },
        l = new e(r),
        u = function (e, n) {
          try {
            var t = Promise.resolve(l.user()).then(function (e) {
              i = e;
            });
          } catch (e) {
            return n();
          }
          return t && t.then ? t.then(void 0, n) : t;
        }(0, function () {
          if (!l.fallbackLoginOptions.scope.includes("wallet")) throw new Error('Must request the "wallet" scope for connector to work.');
          return r.shouldLoginWithRedirect ? Promise.resolve(l.login()).then(function () {
            return Promise.resolve(new Promise(function () {})).then(function () {
              throw new Error("Should never get here.");
            });
          }) : Promise.resolve(l.loginWithPopup()).then(function () {
            return Promise.resolve(l.user()).then(function (e) {
              i = e;
            });
          });
        });
      return Promise.resolve(u && u.then ? u.then(c) : c());
    } catch (e) {
      return Promise.reject(e);
    }
  }, e.display = {
    name: "Unstoppable",
    logo: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIyLjczMTkgMi4wNjkzNFY5Ljg3MjI5TDAgMTkuMDk0TDIyLjczMTkgMi4wNjkzNFoiIGZpbGw9IiMyRkU5RkYiLz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE4LjQ2OTYgMS43MTM4N1YxNS4xOTE3QzE4LjQ2OTYgMTkuMTA5NCAxNS4yODkyIDIyLjI4NTMgMTEuMzY1OSAyMi4yODUzQzcuNDQyNjUgMjIuMjg1MyA0LjI2MjIxIDE5LjEwOTQgNC4yNjIyMSAxNS4xOTE3VjkuNTE2ODJMOC41MjQ0MyA3LjE3NTk0VjE1LjE5MTdDOC41MjQ0MyAxNi41NjI5IDkuNjM3NTkgMTcuNjc0NSAxMS4wMTA3IDE3LjY3NDVDMTIuMzgzOSAxNy42NzQ1IDEzLjQ5NyAxNi41NjI5IDEzLjQ5NyAxNS4xOTE3VjQuNDQ0OUwxOC40Njk2IDEuNzEzODdaIiBmaWxsPSIjNEM0N0Y3Ii8+PC9zdmc+",
    description: "Enter your Unstoppable domain name"
  }, e.getUAuth = function (e, n) {
    return new e(n);
  }, e.registerWeb3Modal = function (e) {
    o = e;
  };
});